/* Where to buy — store locator (Leaflet + OpenStreetMap). Markup: snippets/slx-store-locator.liquid */
(function () {
  if (window.SLX) return;

  var LIBS = {
    css: ['https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css', 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.min.css'],
    leaflet: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js',
    cluster: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.js'
  };
  var COUNTRY = {
    LV: 'Latvia', LT: 'Lithuania', EE: 'Estonia', FI: 'Finland', SE: 'Sweden', NO: 'Norway', DK: 'Denmark',
    PL: 'Poland', DE: 'Germany', NL: 'Netherlands', BE: 'Belgium', FR: 'France', AT: 'Austria', CH: 'Switzerland',
    CZ: 'Czechia', SK: 'Slovakia', HU: 'Hungary', SI: 'Slovenia', HR: 'Croatia', RO: 'Romania', BG: 'Bulgaria',
    IT: 'Italy', ES: 'Spain', GB: 'United Kingdom', UA: 'Ukraine', US: 'United States'
  };
  // Metaobject entries store the country name (admin dropdown); the locator works with ISO codes.
  var CODE = {};
  Object.keys(COUNTRY).forEach(function (c) { CODE[COUNTRY[c]] = c; });
  var BALTIC = ['LV', 'LT', 'EE'];
  function rank(s) {
    var b = BALTIC.indexOf(s.country);
    return s.official ? -1 : (b !== -1 ? b : BALTIC.length);
  }
  var ICON = {
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/></svg>',
    route: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 11l18-8-8 18-2-8-8-2z"/></svg>',
    web: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="9" y="9" width="13" height="13"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    pin: '<svg viewBox="0 0 28 36" aria-hidden="true"><path d="M14 0C6.3 0 0 6.2 0 13.9 0 24.3 14 36 14 36s14-11.7 14-22.1C28 6.2 21.7 0 14 0z" fill="#DB153A"/><path d="M14 0C6.3 0 0 6.2 0 13.9 0 24.3 14 36 14 36s14-11.7 14-22.1C28 6.2 21.7 0 14 0z" fill="none" stroke="#fff" stroke-width="2"/><rect x="9.5" y="9.5" width="9" height="9" fill="#fff"/></svg>'
  };
  var MOBILE = window.matchMedia('(max-width: 989px)');
  var MOBILE_LIMIT = 5;
  var libsPromise = null;
  var instances = [];

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function loadLibs() {
    if (libsPromise) return libsPromise;
    LIBS.css.forEach(function (href) {
      if (document.querySelector('link[href="' + href + '"]')) return;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l);
    });
    libsPromise = (window.L ? Promise.resolve() : loadScript(LIBS.leaflet)).then(function () {
      if (window.L.markerClusterGroup) return;
      return loadScript(LIBS.cluster).catch(function () {});
    });
    return libsPromise;
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function host(url) {
    try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return url; }
  }
  function fullAddress(s) { return s.address + ', ' + (COUNTRY[s.country] || s.country); }
  function directions(s) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(fullAddress(s));
  }
  function km(a, b) {
    var R = 6371, rad = function (x) { return x * Math.PI / 180; };
    var dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
    var h = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.pow(Math.sin(dLng / 2), 2);
    return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function fmtKm(d) { return d < 10 ? d.toFixed(1) + ' km' : Math.round(d) + ' km'; }

  function Locator(root) {
    this.root = root;
    this.isModal = root.classList.contains('slx--modal');
    this.list = root.querySelector('[data-slx-list]');
    this.search = root.querySelector('[data-slx-search]');
    this.nearBtn = root.querySelector('[data-slx-near]');
    this.chips = root.querySelector('[data-slx-chips]');
    this.mapEl = root.querySelector('[data-slx-map]');
    this.moreBtn = root.querySelector('[data-slx-more]');
    this.countEl = root.querySelector('[data-slx-count]');
    this.statusEl = root.querySelector('[data-slx-status]');
    this.live = root.querySelector('[data-slx-live]');
    this.country = 'all';
    this.query = '';
    this.me = null;
    this.expanded = false;
    this.markers = {};
    this.activeId = null;
    try {
      this.stores = JSON.parse(root.querySelector('[data-slx-data]').textContent)
        .map(function (s) {
          s.country = CODE[s.country] || s.country;
          s.lat = parseFloat(s.lat); s.lng = parseFloat(s.lng);
          return s;
        })
        .filter(function (s) { return s.name && isFinite(s.lat) && isFinite(s.lng) && Math.abs(s.lat) <= 90 && Math.abs(s.lng) <= 180; })
        // Official store first, then Latvia, Lithuania, Estonia, then other countries A–Z; stores by name.
        .sort(function (a, b) {
          return rank(a) - rank(b) ||
            (COUNTRY[a.country] || a.country).localeCompare(COUNTRY[b.country] || b.country) ||
            a.name.localeCompare(b.name);
        })
        .map(function (s, i) { s.id = i; return s; });
    } catch (e) { this.stores = []; }

    this.buildChips();
    this.bind();
    this.render();
    this.observe();
  }

  Locator.prototype.visible = function () {
    var q = this.query, c = this.country, me = this.me;
    var arr = this.stores.filter(function (s) {
      if (c !== 'all' && s.country !== c) return false;
      if (!q) return true;
      return (s.name + ' ' + s.address + ' ' + (COUNTRY[s.country] || '')).toLowerCase().indexOf(q) !== -1;
    });
    if (me) arr = arr.slice().sort(function (a, b) { return a._km - b._km; });
    return arr;
  };

  Locator.prototype.buildChips = function () {
    var counts = {};
    this.stores.forEach(function (s) { counts[s.country] = (counts[s.country] || 0) + 1; });
    var codes = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
    var html = '<button type="button" class="slx__chip" data-c="all" aria-pressed="true">All<span>' + this.stores.length + '</span></button>';
    codes.forEach(function (code) {
      html += '<button type="button" class="slx__chip" data-c="' + code + '" aria-pressed="false">' + esc(COUNTRY[code] || code) + '<span>' + counts[code] + '</span></button>';
    });
    this.chips.innerHTML = html;
  };

  Locator.prototype.setCountry = function (code) {
    this.country = code;
    this.chips.querySelectorAll('.slx__chip').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-c') === code ? 'true' : 'false');
    });
  };

  Locator.prototype.row = function (s, n) {
    var actions = '';
    if (s.phone) actions += '<a class="slx-act" href="tel:' + esc(s.phone.replace(/[^\d+]/g, '')) + '">' + ICON.phone + esc(s.phone) + '</a>';
    actions += '<a class="slx-act" href="' + esc(directions(s)) + '" target="_blank" rel="noopener">' + ICON.route + 'Directions</a>';
    if (s.website) actions += '<a class="slx-act" href="' + esc(s.website) + '" target="_blank" rel="noopener">' + ICON.web + esc(host(s.website)) + '</a>';
    actions += '<button type="button" class="slx-act" data-slx-copy="' + s.id + '">' + ICON.copy + '<span>Copy address</span></button>';
    return '<li class="slx-item' + (s.official ? ' is-official' : '') + (s.id === this.activeId ? ' is-active' : '') + '" data-id="' + s.id + '">' +
      '<button type="button" class="slx-item__main" data-slx-focus="' + s.id + '" aria-label="Show ' + esc(s.name) + ' on the map">' +
        '<span class="slx-num">' + n + '</span>' +
        '<span class="slx-item__body">' +
          '<span class="slx-name">' + esc(s.name) +
            (s.official ? '<span class="slx-tag">Official store</span>' : '') +
            (s._km != null && this.me ? '<span class="slx-dist">' + fmtKm(s._km) + '</span>' : '') +
          '</span>' +
          '<span class="slx-addr">' + esc(fullAddress(s)) + '</span>' +
        '</span>' +
      '</button>' +
      '<div class="slx-item__actions">' + actions + '</div>' +
    '</li>';
  };

  Locator.prototype.render = function (fit) {
    var self = this, arr = this.visible();
    this.list.innerHTML = arr.length
      ? arr.map(function (s, i) { return self.row(s, i + 1); }).join('')
      : '<li class="slx-empty">No stores found. Try another city or country.</li>';
    this.countEl.textContent = arr.length + (arr.length === 1 ? ' store' : ' stores');
    this.statusEl.textContent = this.me ? 'Sorted by distance' : '';
    this.list.scrollTop = 0;
    this.applyLimit();
    this.syncMarkers(arr, fit);
  };

  Locator.prototype.applyLimit = function () {
    var items = this.list.querySelectorAll('.slx-item');
    var limit = MOBILE.matches && !this.isModal && !this.expanded && items.length > MOBILE_LIMIT;
    items.forEach(function (li, i) { li.classList.toggle('is-hidden', limit && i >= MOBILE_LIMIT); });
    var show = MOBILE.matches && !this.isModal && items.length > MOBILE_LIMIT;
    this.moreBtn.hidden = !show;
    if (show) this.moreBtn.textContent = this.expanded ? 'Show less' : 'Show all ' + items.length + ' stores';
  };

  Locator.prototype.popup = function (s) {
    return '<div class="slx-pop"><strong>' + esc(s.name) + '</strong>' + esc(fullAddress(s)) +
      (s.phone ? '<br><a href="tel:' + esc(s.phone.replace(/[^\d+]/g, '')) + '">' + esc(s.phone) + '</a>' : '') +
      '<span class="slx-pop__links"><a href="' + esc(directions(s)) + '" target="_blank" rel="noopener">Directions</a>' +
      (s.website ? '<a href="' + esc(s.website) + '" target="_blank" rel="noopener">Website</a>' : '') + '</span></div>';
  };

  Locator.prototype.initMap = function () {
    if (this.mapReady) return this.mapReady;
    var self = this;
    this.mapReady = loadLibs().then(function () {
      var L = window.L;
      self.map = L.map(self.mapEl, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'
      }).addTo(self.map);
      self.map.attributionControl.setPrefix(false);
      self.map.on('click focus', function () { self.map.scrollWheelZoom.enable(); });
      self.map.on('mouseout', function () { self.map.scrollWheelZoom.disable(); });

      var icon = L.divIcon({ className: 'slx-pin', html: ICON.pin, iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -32] });
      self.layer = L.markerClusterGroup
        ? L.markerClusterGroup({
            showCoverageOnHover: false, maxClusterRadius: 44, spiderfyOnMaxZoom: true,
            iconCreateFunction: function (c) {
              return L.divIcon({ className: 'slx-cluster', html: '<span>' + c.getChildCount() + '</span>', iconSize: [38, 38] });
            }
          })
        : L.layerGroup();
      self.layer.addTo(self.map);
      self.stores.forEach(function (s) {
        var m = L.marker([s.lat, s.lng], { icon: icon, title: s.name, alt: s.name, riseOnHover: true });
        m.bindPopup(self.popup(s), { closeButton: true, autoPanPadding: [24, 24] });
        m.on('click', function () { self.setActive(s.id, true); });
        self.markers[s.id] = m;
      });
      self.syncMarkers(self.visible(), true);
      self.map.on('dragstart', function () { self.touched = true; });
      if (window.ResizeObserver) new ResizeObserver(function () { self.refit(); }).observe(self.mapEl);
    });
    return this.mapReady;
  };

  Locator.prototype.syncMarkers = function (arr, fit) {
    if (!this.map) return;
    var self = this, L = window.L;
    this.layer.clearLayers();
    var pts = [];
    arr.forEach(function (s) { self.layer.addLayer(self.markers[s.id]); pts.push([s.lat, s.lng]); });
    if (this.meMarker) { this.meMarker.remove(); this.meMarker = null; }
    if (this.me) {
      this.meMarker = L.circleMarker([this.me.lat, this.me.lng], { radius: 8, color: '#fff', weight: 3, fillColor: '#242833', fillOpacity: 1 })
        .addTo(this.map).bindTooltip('You are here');
    }
    if (fit === false) return;
    if (this.me && arr.length) {
      var near = arr.slice(0, 3).map(function (s) { return [s.lat, s.lng]; }).concat([[this.me.lat, this.me.lng]]);
      this.map.fitBounds(near, { padding: [48, 48], maxZoom: 12 });
    } else if (pts.length) {
      this.map.fitBounds(pts, { padding: [40, 40], maxZoom: 13 });
    } else {
      this.map.setView([56.95, 24.1], 5);
    }
  };

  // Container size changed (modal opened, layout shift): keep the map filled and framed until the user takes over.
  Locator.prototype.refit = function () {
    if (!this.map || !this.mapEl.offsetWidth) return;
    this.map.invalidateSize();
    if (!this.touched) this.syncMarkers(this.visible(), true);
  };

  Locator.prototype.setActive = function (id, scrollList) {
    this.activeId = id;
    var li = null;
    this.list.querySelectorAll('.slx-item').forEach(function (n) {
      var on = Number(n.getAttribute('data-id')) === id;
      n.classList.toggle('is-active', on);
      if (on) li = n;
    });
    if (scrollList && li && this.list.scrollHeight > this.list.clientHeight) {
      this.list.scrollTo({ top: li.offsetTop - this.list.offsetTop - 8, behavior: 'smooth' });
    }
  };

  Locator.prototype.focus = function (id) {
    var self = this;
    this.touched = true;
    this.setActive(id, false);
    if (MOBILE.matches && !this.isModal) this.mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.initMap().then(function () {
      var m = self.markers[id];
      if (!m) return;
      var open = function () { if (!m.isPopupOpen()) m.openPopup(); };
      if (self.layer.zoomToShowLayer) {
        self.layer.zoomToShowLayer(m, open);
        // zoomToShowLayer skips its callback when the marker is already on screen
        setTimeout(open, 700);
      } else {
        self.map.setView(m.getLatLng(), 14);
        open();
      }
    });
  };

  Locator.prototype.locate = function () {
    var self = this, btn = this.nearBtn;
    if (!navigator.geolocation) { this.say('Location is not available in this browser.'); return; }
    btn.setAttribute('aria-busy', 'true');
    btn.querySelector('span').textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(function (pos) {
      self.me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      self.touched = true;
      self.stores.forEach(function (s) { s._km = km(self.me, s); });
      self.query = ''; self.search.value = '';
      self.setCountry('all');
      self.expanded = false;
      btn.removeAttribute('aria-busy');
      btn.querySelector('span').textContent = 'Near me';
      self.render(false);
      self.initMap().then(function () { self.syncMarkers(self.visible(), true); });
      var first = self.visible()[0];
      if (first) self.say('Nearest store: ' + first.name + ', ' + fmtKm(first._km) + '.');
    }, function () {
      btn.removeAttribute('aria-busy');
      btn.querySelector('span').textContent = 'Near me';
      self.say('We could not get your location. Search by city instead.');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  };

  Locator.prototype.say = function (msg) {
    this.live.textContent = msg;
    this.statusEl.textContent = msg;
  };

  Locator.prototype.bind = function () {
    var self = this, t;
    this.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        self.query = self.search.value.trim().toLowerCase();
        self.expanded = false;
        self.render();
      }, 150);
    });
    this.chips.addEventListener('click', function (e) {
      var b = e.target.closest('.slx__chip'); if (!b) return;
      self.setCountry(b.getAttribute('data-c'));
      self.expanded = false;
      self.render();
    });
    this.nearBtn.addEventListener('click', function () { self.locate(); });
    this.moreBtn.addEventListener('click', function () {
      self.expanded = !self.expanded;
      self.applyLimit();
      if (!self.expanded) self.list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    this.list.addEventListener('click', function (e) {
      var f = e.target.closest('[data-slx-focus]');
      if (f) { self.focus(Number(f.getAttribute('data-slx-focus'))); return; }
      var c = e.target.closest('[data-slx-copy]');
      if (c) {
        var s = self.stores[Number(c.getAttribute('data-slx-copy'))];
        var label = c.querySelector('span');
        var done = function () {
          label.textContent = 'Copied';
          self.live.textContent = 'Address copied';
          setTimeout(function () { label.textContent = 'Copy address'; }, 1400);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(fullAddress(s)).then(done, function () {});
      }
    });
    MOBILE.addEventListener ? MOBILE.addEventListener('change', function () { self.applyLimit(); }) : MOBILE.addListener(function () { self.applyLimit(); });
  };

  Locator.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) { this.initMap(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); self.initMap(); }
    }, { rootMargin: '300px' });
    io.observe(this.mapEl);
  };

  function boot() {
    document.querySelectorAll('[data-slx-locator]').forEach(function (root) {
      if (root.__slx) return;
      root.__slx = new Locator(root);
      instances.push(root.__slx);
    });
  }

  window.SLX = {
    boot: boot,
    refresh: function () {
      instances.forEach(function (inst) {
        if (inst.map) inst.refit();
        else if (inst.root.offsetParent) inst.initMap();
      });
    }
  };
  // Product-page modal (snippets/slx-wtb-modal.liquid) calls these on open.
  window.__slxBootLocator = function () { boot(); window.SLX.refresh(); };
  window.__slxForceMapResize = window.SLX.refresh;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
